import React from 'react';
import { ChevronRight, CheckCircle, Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export const Hero = () => {
  const {
    t
  } = useLanguage();
  const scrollToPricing = () => {
    const element = document.getElementById('precios');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full bg-gradient-to-br from-blue-50 via-white to-blue-50 py-8 md:py-20" data-id="element-142">
      <div className="container mx-auto px-3 md:px-8 flex flex-col lg:flex-row items-center" data-id="element-143">
        <div className="lg:w-1/2 mb-6 lg:mb-0" data-id="element-144">
          <div className="inline-flex items-center bg-blue-100 text-blue-800 px-3 py-1.5 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-semibold mb-4 md:mb-6" data-id="element-145">
            <Sparkles className="mr-2" size={16} data-id="element-146" />
            {t('hero.badge')}
          </div>
          <h2 className="text-2xl md:text-5xl font-bold text-navy-900 mb-4 md:mb-6 leading-tight" data-id="element-147">
            {t('hero.title')}
          </h2>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bpNRtGjVABAj8edztGr2ow/WhatsApp_Image_2025-11-14_at_16.10.20.jpg" alt="Happy dog playing with BranRok Jump Ball" className="w-full h-auto rounded-2xl shadow-lg mb-4 md:mb-6 md:hidden" data-id="element-148" />
          <h3 className="text-xl md:text-3xl font-semibold text-blue-700 italic mb-4 md:mb-8" data-id="element-149">
            {t('hero.subtitle')}
          </h3>
          <p className="text-base md:text-lg text-gray-700 mb-4 md:mb-8 leading-relaxed" data-id="element-150">
            {t('hero.description')}
          </p>
          <div className="bg-white p-4 md:p-6 rounded-xl shadow-lg mb-4 md:mb-8 border-l-4 border-blue-500" data-id="element-151">
            <h4 className="text-base md:text-lg font-bold mb-3 md:mb-4 text-navy-900 flex items-center" data-id="element-152">
              <Sparkles className="mr-2 text-blue-500" size={20} data-id="element-153" />
              {t('hero.benefitsTitle')}
            </h4>
            <ul className="space-y-2 md:space-y-3" data-id="element-154">
              {[t('hero.benefit1'), t('hero.benefit2'), t('hero.benefit3'), t('hero.benefit4'), t('hero.benefit5'), t('hero.benefit6')].map((benefit, index) => <li key={index} className="flex items-start" data-id="element-155">
                  <CheckCircle className="text-green-500 mr-2 md:mr-3 mt-0.5 flex-shrink-0" size={18} data-id="element-156" />
                  <span className="text-sm md:text-base text-gray-700" data-id="element-157">
                    {benefit}
                  </span>
                </li>)}
            </ul>
          </div>
          <button onClick={scrollToPricing} className="flex items-center justify-center bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold py-3 md:py-4 px-6 md:px-8 rounded-lg text-base md:text-lg transition duration-300 w-full md:w-auto shadow-lg transform hover:scale-105" data-id="element-158">
            {t('hero.cta')}
            <ChevronRight className="ml-2" size={20} data-id="element-159" />
          </button>
        </div>
        <div className="lg:w-1/2 lg:pl-10" data-id="element-160">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uyvRgaW7h8n3tpCXxGriZo/Generated_Image_November_14%2C_2025_-_4_12PM.png" alt="Dogs playing with the BranRok Jump Ball" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-161" />
        </div>
      </div>
    </section>;
};